"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// ? 개행문자 -> <br/>
function default_1(str) {
    return str.replace(/(?:\r\n|\r|\n)/g, '<br/>');
}
exports.default = default_1;
